import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext(null);
const KEY = "pn_theme";

// Light mode is temporarily disabled while we work through readability
// issues. The app forces dark regardless of any stored preference so we
// can re-enable light later by simply restoring the previous logic.
function applyTheme() {
  const root = document.documentElement;
  root.classList.remove("light");
  root.classList.add("dark");
  return "dark";
}

export function ThemeProvider({ children }) {
  const [theme] = useState("dark");

  useEffect(() => {
    applyTheme();
    localStorage.setItem(KEY, "dark");
  }, []);

  const cycle = useCallback(() => {}, []);
  const setTheme = useCallback(() => {}, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, cycle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
